import { Box, Checkbox, Drawer, Typography, TextField, Button, IconButton } from "@mui/material";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { useEffect, useState } from "react";
import { upgradeUserDetails } from "../../../../actions/user";
import { useDispatch } from "react-redux";

const ApplicationStatusDrawer = ({ open, onClose, type, item ,setUpdateType,updateType}) => {
    const [status, setStatus] = useState(""); // Track selected status
    const [notes, setNotes] = useState("")
    const dispatch = useDispatch();
   
    useEffect(() => {
        setNotes(item?.notes)
        setStatus(item?.status)
    }, [])

    const uncheckedStyle = {
        width: 16,
        height: 16,
        borderRadius: "4px",
        border: "1px solid #2f2f2f",
        backgroundColor: "#e1e5e8",
        transition: "all 0.3s ease",
    };

    const checkedStyle = {
        width: 16,
        height: 16,
        borderRadius: "4px",
        backgroundColor: "black",
        border: "1px solid black",
        transition: "all 0.3s ease",
    };

    const handleStatusChange = (value) => {
        console.log(value)
        setStatus(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let data = {
            status: status,
            notes: notes
        }
        try {
            const res = await dispatch(upgradeUserDetails(item?._id, data)).then((res) => {
                setNotes(res?.data?.notes)
                setStatus(res?.data?.status)
                setUpdateType(!updateType)
                onClose()
            // console.log("resp",res)  
            });
        } catch (error) {
            console.error("Error updating user details:", error);
        }



    };

    return (
        <>
            <Drawer anchor="right"
                open={open}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        top: "0px  !important",
                        backgroundColor: "#fafafa",
                        padding: "10px",
                    },
                    "& .MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px  !important",
                    },
                    "& .MuiBackdrop-root": {
                        backgroundColor: "rgba(0, 0, 0, 0.1) !important", // Ensure same backdrop color
                    },
                    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px !important"
                    }
                }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", marginTop: 2 }}>
                        <Typography
                            className="sofiaRegular"
                            variant="body1"
                            fontWeight="bold"
                            sx={{ fontSize: "16px", mb: 0 }}
                        >
                            Manage Applications Status
                        </Typography>
                        <Typography
                            className="sofiaRegular"
                            variant="body2"
                            sx={{ fontSize: "14px", marginBottom: 2, color: "#211f1f" }}
                        >
                            {type === "trade" ? "Trade Application" : "Trade + Application"}
                        </Typography>
                    </Box>
                    <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent", }, }} onClick={onClose}>
                        <CancelRoundedIcon />
                    </IconButton>
                </Box>
                <form onSubmit={handleSubmit}>
                    <Box
                        className="sofiaRegular"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid black",
                            borderRadius: 2,
                            padding: "8px 12px",
                            backgroundColor: "#ffffff",
                            cursor: "pointer",
                            "&:hover": {
                                borderColor: "black",
                            },
                            height: "60px",
                            mt: 4,

                        }}
                        onClick={() => handleStatusChange("approved")} // Clicking toggles checkbox
                    >
                        {/* Custom Checkbox */}
                        <Checkbox
                            checked={status === "approved"}
                            onChange={() => handleStatusChange("approved")}
                            icon={<Box sx={uncheckedStyle} />}
                            checkedIcon={<Box sx={checkedStyle} />}
                            sx={{ padding: "0px !important", marginRight: "6px" }}
                        />
                        {/* Checkbox Label */}
                        <Typography className="sofiaRegular" sx={{ fontWeight: "bold", fontSize: 16 }}>
                            Approved Application
                        </Typography>
                    </Box>
                    <Box sx={{ border: "1px solid #c5c5c5", backgroundColor: "#fff", p: 2, mt: 2, mb: 1.5, borderRadius: "6px" }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            {/* Custom Checkbox */}
                            <Checkbox
                                checked={status === "rejected"}
                                onChange={() => handleStatusChange("rejected")}
                                icon={<Box sx={uncheckedStyle} />}
                                checkedIcon={<Box sx={checkedStyle} />}
                                sx={{ padding: "0px !important", marginRight: "6px" }}
                            />
                            {/* Checkbox Label */}
                            <Typography className="sofiaRegular" sx={{ fontWeight: "bold", fontSize: 16 }}>
                                Deny Application
                            </Typography>
                        </Box>
                        <TextField
                            className="sofiaRegular"
                            fullWidth
                            disabled={status === "approved"}
                            value={notes}
                            placeholder="Include reason for denial (optional)"
                            variant="outlined"
                            multiline
                            minRows={3}
                            onChange={(e) => setNotes(e.target.value)}
                            sx={{
                                 bgcolor: "#fafafa", borderRadius: "6px", mt: 2, "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        border: "1px solid #0d0d0d !important",
                                    },
                                },
                            }}
                        />
                    </Box>

                    {/* Update Application Status Button */}
                    <Button
                        disabled={!status}
                        fullWidth
                        className="sofiaRegular"
                        variant="contained"
                        type="submit"
                        sx={{
                            bgcolor: "#000",
                            color: "#fff",
                            fontWeight: "bold",
                            p: "10px !important",
                            textTransform: "none",
                            borderRadius: "8px",
                            border: "1px solid #090909",
                            "&:hover": { bgcolor: "#222" },
                            "&.Mui-disabled": {
                                border: "1px solid rgba(0, 0, 0, 0.26)"
                            }
                        }}
                    >
                        Update Application Status
                    </Button>
                </form>
            </Drawer>
        </>
    )
}

export default ApplicationStatusDrawer